import { TableHeaderColumn } from '@/modules/drivers/types/table'

export const getVehiclesColumns = (t: (key: string) => string): TableHeaderColumn[] => [
  {
    title: t('vehicleBasics.registration-number'),
    key: 'registrationNumber',
    type: 'string',
    sort: true,
  },
  {
    title: t('vehicleBasics.vin-number'),
    key: 'vinNumber',
    type: 'string',
    sort: true,
  },
  {
    title: t('vehicleBasics.make'),
    key: 'make',
    type: 'string',
    sort: true,
  },
  {
    title: t('vehicleBasics.model'),
    key: 'model',
    type: 'string',
    sort: true,
  },
]

export const getVehicleLocksColumns = (t: (key: string) => string): TableHeaderColumn[] => [
  { title: t('vehicleModule.lock-start'), key: null, type: 'date', sort: false },
  { title: t('vehicleModule.lock-end'), key: null, type: 'date', sort: false },
  { title: t('vehicleModule.locking-company'), key: null, type: 'string', sort: false },
  { title: t('vehicleModule.card-number'), key: null, type: 'string', sort: false },
  // { title: t('vehicleBasics.registration-number-from-tachograph'), key: null, type: 'number', sort: false },
]

export const getVehicleActivitiesColumns = (t: (key: string) => string): TableHeaderColumn[] => [
  { title: t('activity.title'), key: null, type: 'string', sort: false },
  { title: t('common.from'), key: null, type: 'date', sort: false },
  { title: t('common.to'), key: null, type: 'date', sort: false },
  { title: t('vehicleModule.duration'), key: null, type: 'string', sort: false },
  { title: t('vehicleBasics.registration-number'), key: null, type: 'number', sort: false },
  { title: t('activity.crew'), key: null, type: 'number', sort: false },
  { title: t('activity.ferry-crossing'), key: null, type: 'number', sort: false },
  { title: t('activity.out-of-scope'), key: null, type: 'number', sort: false },
  { title: t('activity.manual-entry'), key: null, type: 'number', sort: false },
]
